<template>
<!--
<span class="heading-style">
{{this.projectname}}
<span class="headertext-space">|</span>
{{this.title}} 
</span>-->
 <v-row>
    <v-col><v-toolbar-title class="page-top-legend-tile">{{this.projectname}}</v-toolbar-title></v-col></v-row>
</template>

<script>
import globalstorage from "../global/GlobalStrorage";
import {
    defineComponent
} from '@vue/composition-api'

export default defineComponent({
      props: {
        title: {
            type: String,
            default: '',
        }
    },
     data: () => ({
          projectname: globalstorage.getProjectName() + '('+ globalstorage.getProjectID() +')',
         // projectname: globalstorage.getProjectName(),
     }),
    setup() {

    },
})
</script>
<style scoped>
.heading-style{
    font-weight: bold;
}
.headertext-space{
    padding-left: 5px !important;
    padding-right: 5px !important;
}
</style>
